























































import { Component, Vue, Prop } from "vue-property-decorator";
import { TradeOrder, TradeSide } from "@foxone/api/src/models/market";
import utils from "trade/utils";

@Component
class AutoTradeOrderItem extends Vue {
  @Prop() order!: TradeOrder;

  @Prop() last!: boolean;

  @Prop() first!: boolean;

  get meta() {
    const {
      side,
      amount,
      status,
      base,
      quote,
      base_asset,
      quote_asset,
      obtained_amount,
      fee
    } = this.order;
    const sideMeta = utils.enums.getTradeSideMeta(side);
    const statusMeta = utils.enums.getAutoTradeStatusMeta(status);
    const filledAmount = this.order.filled_amount;
    const displaySymbol = `${base}/${quote}`;
    const sellUnit = side === TradeSide.ASK ? base : quote;
    const sellUnitAsset = side === TradeSide.ASK ? base_asset : quote_asset;
    const obtainedUnit = side === TradeSide.ASK ? quote : base;
    return {
      sellUnit,
      obtainedUnit,
      base,
      quote,
      amount,
      sellUnitAsset,
      displaySymbol,
      baseAsset: base_asset,
      feeText: `${fee} ${obtainedUnit}`,
      sideText: this.$t(sideMeta.text),
      sideColor: sideMeta.color,
      statusText: this.$t(statusMeta.text),
      statusColor: statusMeta.color,
      sellAmountText: `${filledAmount}/${amount}`,
      obtainedAmountText: `${obtained_amount}`,
      avgPrice: this.order.avg_price || "-"
    };
  }
}
export default AutoTradeOrderItem;
